import {
  GET_CONTACT_LIST_DATA, GET_CONTACT_PERSON_BY_EMAIL_DATA, GET_CONTACT_COMPANY_BY_DOMAIN_DATA,
  DELETE_CONTACT_LIST, SAVE_CONTACT_LIST_DATA, RESET_CONTACT_COMPANY_DATA, RESET_CONTACT_PERSON_DATA,
} from '../../constants/system/actions';

const getContactListData: Function = (
  payload?: ActionPayload, resolve?: Function, reject?: Function,
): ReduxAction => ({
  type: GET_CONTACT_LIST_DATA, payload, resolve, reject,
});

const getContactCompanyByDomainData: Function = (
  payload?: ActionPayload, resolve?: Function, reject?: Function,
): ReduxAction => ({
  type: GET_CONTACT_COMPANY_BY_DOMAIN_DATA, payload, resolve, reject,
});

const getContactPersonByEmailData: Function = (
  payload?: ActionPayload, resolve?: Function, reject?: Function,
): ReduxAction => ({
  type: GET_CONTACT_PERSON_BY_EMAIL_DATA, payload, resolve, reject,
});

const saveContactListData: Function = (
  payload?: ActionPayload, resolve?: Function, reject?: Function,
): ReduxAction => ({
  type: SAVE_CONTACT_LIST_DATA, payload, resolve, reject,
});

const deleteContactList: Function = (
  payload?: ActionPayload, resolve?: Function, reject?: Function,
): ReduxAction => ({
  type: DELETE_CONTACT_LIST, payload, resolve, reject,
});

const resetContactCompanyData: Function = (payload?: ActionPayload): ReduxAction => ({
  type: RESET_CONTACT_COMPANY_DATA, payload,
});

const resetContactPersonData: Function = (payload?: ActionPayload): ReduxAction => ({
  type: RESET_CONTACT_PERSON_DATA, payload,
});

export {
  getContactListData,
  getContactCompanyByDomainData,
  getContactPersonByEmailData,
  saveContactListData,
  deleteContactList,
  resetContactCompanyData,
  resetContactPersonData,
};
